var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroBlur1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 857,
    height: 762,
    viewBox: "0 0 857 762",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1_24)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 653.453,
    cy: 111.5,
    rx: 188.5,
    ry: 186.5,
    fill: "url(#paint0_linear_1_24)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_24",
    x: 0.953125,
    y: -539,
    width: 1305,
    height: 1301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 232,
    result: "effect1_foregroundBlur_1_24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_24",
    x1: 458.14,
    y1: 78.3445,
    x2: 842.205,
    y2: 81.1465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10A9E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBlur1);
export default __webpack_public_path__ + "static/media/hero-blur-1.87cd007cc0fa271b1ed0ddf364e9bbd2.svg";
export { ForwardRef as ReactComponent };